import { Component, OnInit } from '@angular/core';
import { DealersModel } from 'src/app/model/DealersModel';
import { DealersService } from 'src/app/services/dealers.service';

@Component({
  selector: 'app-dealers-content',
  templateUrl: './dealers-content.component.html',
  styleUrls: ['./dealers-content.component.css']
})
export class DealersContentComponent implements OnInit {

dealersData:DealersModel[]=[];
searchModel:string;
filterData:DealersModel[]=[];

  constructor(private dealersService: DealersService) { 
      
  this.loadDealers();
  }
async loadDealers()
{

  let res = await this.dealersService.LTEAllDealers( ).toPromise();
 
  this.dealersData = <DealersModel[]> res.Result;
  this.filterData = this.dealersData;

}
  ngOnInit() {
  }

  valuechange(newValue) {
    this.searchModel = newValue;
  
  

    if (this.searchModel.length==0)
    {
      this.filterData =this.dealersData;
    }
    else
    {

      this.filterData = this.dealersData.filter(x => x.Name.toLowerCase().includes(this.searchModel.toLowerCase()));
     

    }

    
  }




}
